import Vue from 'vue';
import VueRouter from 'vue-router';
import HomeView from '../views/HomeView.vue';
import AboutUs from '../views/AboutUs.vue';
import Solution from '../views/Solution.vue';
import CompanyProducts from '../views/CompanyProducts.vue';
import SystemDetails from '../views/SystemDetails.vue';
import EyeChart from '../views/EyeChart.vue';
import ConsumablesDetails from '../views/ConsumablesDetails.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/about-us',
    name: 'AboutUs',
    component: AboutUs
  },
  {
    path: '/Solution',
    name: 'Solution',
    component: Solution
  },
  {
    path: '/CompanyProducts',
    name: 'CompanyProducts',
    component: CompanyProducts
  },
  {
    path: '/SystemDetails',
    name: 'SystemDetails',
    component: SystemDetails
  },
  {
    path: '/EyeChart',
    name: 'EyeChart',
    component: EyeChart
  },
  {
    path: '/ConsumablesDetails',
    name: 'ConsumablesDetails',
    component: ConsumablesDetails
  }

];

const router = new VueRouter({
  mode: 'history', // 去除 URL 中的 # 号
  routes
});

export default router;